// todo 修改template-server
module.exports = {
  OMS_TEMPLATE_SERVER: "http://otms.yunlizhi.cn/hope-saas-oms-web/",
  BFS_SSO_SERVER: "https://sso.yunlizhi.cn",
  BFS_USER_WEB_SERVER: "https://user-web.yunlizhi.cn",
  OTMS_WEB_PLUS_SERVER: "https://otms-web-plus.yunlizhi.cn/",
  SC_SERVER: "http://52.83.239.147:8888",
  SF_SERVER: "http://calculatedistance.sch.pubapi.yunlizhi.cn",
  BIG_DATA_SERVER: "https://bd-inp.yunlizhi.cn",
  DBIS_SERVER: "https://bd-dbis.yunlizhi.cn",
  BIG_DATA_SERVER_WHEREHOUSE: "https://anser.yunlizhi.cn",
  OSS_FILE_SERVER: "https://prod-ylzapp-public.oss-cn-zhangjiakou.aliyuncs.com",
  WMS_WEB_PLUS_SERVER: "https://wms-web-plus.yunlizhi.cn",
  BMS_WEB_PLUS_SERVER: "http://bms-web-plus.yunlizhi.io/",
  BMS_WEB_SERVER: "https://otms-web-plus.yunlizhi.cn/",
  BMS_UI: "https://mp.yunlizhi.cn",
  LOGGER_CONFIG: {
    sentryDsn: "http://3c039c079e70475993cc97ab68437317@sentry.yunlizhi.net/11",
    enable: true,
    release: "V1.0.0",
  },
  ruleIds: ["23", "24", "25", "26"],
  REPLENISHMENT: "https://fresh.newhopescm.com/saas-web/#/",
  appKey: "2150414209",
  secretKey: "42dfae63544a21a11d3b1a42c498c831",
  IFRAME_ORIGIN: "https://app-store.yunlizhi.cn",
  OTMS_UI: "https://otms.yunlizhi.cn/#/",
  OTMS_ADMIN_URL: "https://otms-admin.yunlizhi.cn/#/",
  WMS_IFRAME: "https://fe-wms-v2-admin.yunlizhi.cn/#/",
  wmsTenantIds: ["T10000138"],
  LOGIN_URL: "http://fe-enterprise-portal-system.yunlizhi.cn",
  BMS_BIGDATA: "https://bigdata-schedule-recommend.yunlizhi.cn",
  EXPORT_WEB: "https://export-web.yunlizhi.cn",
  SMART_WIRUNG_SERVER: "https://bigdata-schedule-recommend.yunlizhi.cn",
  MOONBOX: "https://moonbox.ops.yunlizhi.cn",
  NEW_SYSTEM_URL: "https://customer-admin.yunlizhi.cn",
};
